import { render, staticRenderFns } from "./QuestionTitle.vue?vue&type=template&id=3dc7b022&scoped=true"
import script from "./QuestionTitle.vue?vue&type=script&lang=js"
export * from "./QuestionTitle.vue?vue&type=script&lang=js"
import style0 from "./QuestionTitle.vue?vue&type=style&index=0&id=3dc7b022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7b022",
  null
  
)

export default component.exports